module.exports = __webpack_public_path__ + "media/audio27.52213295.mp3";